export function mergeDuplicateKeys(str, separator) {
    var qs = new URLSearchParams(str);
    var newQs = new URLSearchParams();

    qs.forEach((v, k) => {
        if(!newQs.has(k)) {
            newQs.set(k, v);
        } else {
            newQs.set(k, newQs.get(k) + separator + v);
        }
    });
    return newQs.toString();
}

export function addQuerystring(existingQs, key, value) {
    if(!existingQs) return `${key}=${value}`;

    return `${existingQs}&${key}=${value}`;
}

export function addOrUpdateQuerystring(existingQs, key, value) {
    if(!existingQs) return `${key}=${value}`;

    var qs = new URLSearchParams(existingQs);
    if(qs.has(key)) {
        qs.set(key, value);
        return qs.toString();
    } else {
        return `${existingQs}&${key}=${value}`;
    }
}

export function addUrlQuerystring(url, key, value) {
    if(!url) return `${url}?${key}=${value}`;

    return url.indexOf('?') > -1
        ? `${url}&${key}=${value}`
        : `${url}?${key}=${value}`;
}

export function parseJson(qs) {
    if(!qs) return {};
    return JSON.parse('{"' + decodeURI(qs).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}
